var chunkToChildrenMap = {
	"12": [
		686
	],
	"30": [
		886,
		822
	],
	"150": [
		451
	],
	"506": [
		471
	],
	"663": [
		886
	],
	"814": [
		125
	],
	"935": [
		23,
		181
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));